export const formatDataToModel = (data, Model) => {
  const formattedData = new Model();
  for (const key in data) {
    if (formattedData.hasOwnProperty(key)) {
      formattedData[key] = data[key];
    }
  }
  return formattedData;     
}

export const createSelect = (buttonText, label, type, value, multiple) => ({ buttonText, label, type, value, multiple })

// cat = true, mg = true, il = true, eq = true, pbeq = false, fg = true) => {
export const createSelects = (data, oldSelects = [], included) => {
  let selects = [];

  if (!data) return [];
  const dataKeys = Object.keys(data);

  for (const key of dataKeys) {
    if (!Array.isArray(data[key])) {
      continue;
    }

    const value = [...data[key]];
    switch(key) {
      case 'categories':
        if (included.cat) {
          value.push({ name: 'None', slug: 'none' });
          selects.push(createSelect('Categories', 'Choose Categories', 'category', value.map(item => ({ label: item.name, value: item.slug })), true))
        }
        break;
      case 'musclegroups':
        if (included.mg) {
          value.push({ name: 'None'});
          selects.push(createSelect('Muscle Groups', 'Choose Muscle Groups', 'musclegroup', value.map(item => ({ label: item.name, value: item.name })), true))
        }
        break;
      case 'intensity_level':
        if (included.il) {
          value.push({ name: 'None'});
          selects.push(createSelect('Level', 'Choose Intensity Level', 'intensitylevel', value.map(item => ({ label: item.name, value: item.name })), false))
        }
        break;
      case 'equipment':
        if (included.eq) {
          value.push({ name: 'None'});
          selects.push(createSelect('Equipment', 'Choose Equipment', 'equipment', value.map(item => ({ label: item.name, value: item.name, grouping: item.grouping })), true))
        }
        break;
      case 'fitnessgoals':
        if (included.fg) {
          value.push({ name: 'None' });
          selects.push(createSelect('Fitness Goals', 'Choose Fitness Goals', 'fitnessgoals', value.map(item => ({ label: item.name, value: item.name })), false));
        }
        break;
      case 'trainers':
        if (included.tr) {
          selects.push(createSelect('Trainers', 'Choose Trainer', 'trainer', value.map(item => ({ label: item.name, value: item.user_id })), false));
        }
        break;
      default:
        break;
    }
  }

  selects = selects.concat(oldSelects);
  selects.sort((a,b) => a.label - b.label);
  return selects;
}

export const getTabIndex = (url, tabs) => {
  for(let i = tabs.length - 1; i >= 0; i--) {
    if(url.includes(tabs[i].path)) {
      return i;
    }
  }
}

export const arrayMerge = (oldArray, updatedArray, specialType) => {
  if(specialType === "wellnessUnAssignedPrograms"){
    return updatedArray;
  }
  const tempArray = oldArray.concat(updatedArray)

  const uniqueArray = tempArray.filter((thing, index) => {
    return (
      index === tempArray.findIndex(obj => {
        return obj.id === thing.id
      })
    )
  })
 
  return uniqueArray
}

export const secToHHMMSS = sec => {
  let sec_num = sec; // don't forget the second param
  let hours   = Math.floor(sec_num / 3600);
  let minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  let seconds = sec_num - (hours * 3600) - (minutes * 60);

  // if (hours   < 10) {hours   = "0"+hours;}
  // if (minutes < 10) {minutes = "0"+minutes;}
  // if (seconds < 10) {seconds = "0"+seconds;}
  return hours+'h '+minutes+'m '+seconds+'s';
}

export const minToHHMMSS = min => {
  let min_num = min; // don't forget the second param
  let hours   = Math.floor(min_num / 60);
  let minutes = Math.floor(min_num - (hours * 60));
  // let seconds = min_num - (hours * 3600) - (minutes * 60);

  // if (hours   < 10) {hours   = "0"+hours;}
  // if (minutes < 10) {minutes = "0"+minutes;}
  // if (seconds < 10) {seconds = "0"+seconds;}
  return hours+'h '+minutes+'m';
}

export const displayTags = tags => {
  return tags.map(tag => `#${tag}`).join(', ');
}

export const calculateSetDuration = (data, repTime) => {
  let seconds = 0;
  let setCount = 1;
  for (const item of data) {
    const val = item.value ? item.value : 0;
    if (item.type.match('^(warmup|set|cooldown)$')) {
      setCount = val
    } else if (item.type === 'reps'){
      seconds += (val * repTime) * setCount;
    } else {
      seconds += val * setCount;
    }
  }
  return seconds;
}
